import { useEffect, type DependencyList } from 'react';

export function useAsyncEffect(
  effect: () => Promise<void | VoidFunction>,
  deps?: DependencyList,
) {
  useEffect(() => {
    let cleanup: (() => void) | void;

    effect().then(result => {
      cleanup = result;
    });

    return () => {
      cleanup?.();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
